var map = {
	"./american-violence-1.png": "7ac7",
	"./atlas-1.png": "5a09",
	"./grenada-1.png": "a810",
	"./king-of-pops-1.png": "1899",
	"./laurel-gitlen-1.png": "ffe0",
	"./yalobusha-review-1.png": "0bca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5edf";